export interface Property {
  id: string;
  title: string;
  description: string;
  price: number;
  location: string;
  bedrooms: number;
  bathrooms: number;
  area: number; // Square meters or feet
  type: PropertyType;
  images: string[];
  features: string[];
  isNew?: boolean;
  isFeatured?: boolean;
  coordinates?: Coordinates; // Adding coordinates for map integration
  available: boolean; // Property availability status
}

export interface Coordinates {
  lat: number;
  lng: number;
}

export enum PropertyType {
  HOUSE = 'House',
  APARTMENT = 'Apartment',
  VILLA = 'Villa',
  LAND = 'Land',
  COMMERCIAL = 'Commercial'
}